import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./blogDetail.css";

const BlogDetail = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);

    fetch(`${process.env.REACT_APP_API_URL}/blog/${slug}/`)
      .then(res => res.json())
      .then(data => setBlog(data))
      .catch(err => console.error(err));
  }, [slug]);

  if (!blog) return <div className="blog-loading">Loading...</div>;

  return (
    <section className="blogDetail">
      <div className="blogDetailContent">
        <h1 className="blogDetailTitle">{blog.title}</h1>

        {blog.thumbnail && (
          <img
            src={blog.thumbnail}
            alt={blog.title}
            className="blogDetailImage"
          />
        )}

        <div
          className="blogDetailBody"
          dangerouslySetInnerHTML={{ __html: blog.content }}
        />
      </div>
    </section>
  );
};

export default BlogDetail;